import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Bug, Lightbulb, Send, Inbox, Loader2 } from "lucide-react";
import Btn from "../components/Btn";
import api, { apiErr } from "../lib/api";

export default function AdminFeedback() {
  const [items, setItems] = useState(null);
  const [filter, setFilter] = useState("");
  const [replies, setReplies] = useState({});
  const [busy, setBusy] = useState(null);

  const load = () => api.get(`/admin/feedback${filter ? `?status=${filter}` : ""}`).then(({ data }) => setItems(data.feedback)).catch(() => {});
  useEffect(() => { load(); }, [filter]);

  const send = async (id) => {
    const reply = (replies[id] || "").trim();
    if (!reply) { toast.error("Tulis balasan dulu"); return; }
    setBusy(id);
    try {
      await api.post(`/admin/feedback/${id}/reply`, { reply, status: "answered" });
      toast.success("Balasan terkirim!");
      setReplies((r) => ({ ...r, [id]: "" })); load();
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(null); }
  };

  if (!items) return <div className="grid place-items-center py-16"><Loader2 className="w-10 h-10 animate-spin text-su-primary" /></div>;

  return (
    <div className="card-chunky p-6">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <h2 className="font-heading font-bold text-xl">Saran & Laporan Bug</h2>
        <div className="flex gap-2">
          {[["", "Semua"], ["open", "Baru"], ["answered", "Dibalas"]].map(([v, l]) => (
            <button key={v} data-testid={`fb-filter-${v || "all"}`} onClick={() => setFilter(v)}
              className={`px-3 py-1.5 rounded-lg text-sm font-heading font-bold border ${filter === v ? "bg-su-primary text-black border-su-primary" : "border-su-border text-su-muted"}`}>{l}</button>
          ))}
        </div>
      </div>
      {items.length === 0 ? (
        <div className="text-center py-12"><Inbox className="w-12 h-12 text-su-muted mx-auto mb-2" /><p className="text-su-muted font-heading font-bold">Tidak ada laporan</p></div>
      ) : (
        <div className="space-y-3">
          {items.map((f) => (
            <div key={f.id} className="rounded-xl border border-su-border p-4" data-testid={`admin-fb-${f.id}`}>
              <div className="flex items-center gap-2 mb-1">
                {f.type === "bug" ? <Bug className="w-4 h-4 text-su-danger" /> : <Lightbulb className="w-4 h-4 text-su-energy" />}
                <span className="font-heading font-bold flex-1 truncate">{f.title}</span>
                <span className="text-xs text-su-muted">{f.user_name}</span>
                <span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded ${f.status === "open" ? "bg-su-energy/15 text-su-energy" : "bg-su-success/15 text-su-success"}`}>{f.status}</span>
              </div>
              <p className="text-sm text-su-muted mb-3">{f.message}</p>
              {f.reply && <div className="rounded-lg bg-su-primary/10 border border-su-primary/30 p-2.5 mb-2 text-sm"><b className="text-su-primary text-xs">Balasan: </b>{f.reply}</div>}
              <div className="flex items-center gap-2">
                <input data-testid={`admin-fb-reply-${f.id}`} value={replies[f.id] || ""} onChange={(e) => setReplies((r) => ({ ...r, [f.id]: e.target.value }))}
                  placeholder="Tulis balasan..." className="flex-1 px-3 py-2 rounded-lg border border-su-border bg-su-bg text-sm outline-none focus:border-su-primary" />
                <Btn size="sm" data-testid={`admin-fb-send-${f.id}`} disabled={busy === f.id} onClick={() => send(f.id)}><Send className="w-4 h-4" /></Btn>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
